import { toBlob } from "html-to-image";

export type CopyTableAsPngOptions = {
    /** Higher = sharper PNG (larger clipboard payload). Default 3. */
    pixelRatio?: number;
    /** Set true to avoid auto-downscale when canvas would exceed browser limits. */
    skipAutoScale?: boolean;
};

export const copyTableAsPng = async (
    element: HTMLElement,
    options?: CopyTableAsPngOptions
) => {
    const dpr = typeof window !== "undefined" && window.devicePixelRatio ? window.devicePixelRatio : 1;
    const pixelRatio = options?.pixelRatio ?? Math.min(4, Math.max(2.5, dpr * 1.5));
    const w = element.scrollWidth;
    const h = element.scrollHeight;

    const blob = await toBlob(element, {
        cacheBust: true,
        pixelRatio,
        width: w,
        height: h,
        ...(options?.skipAutoScale ? { skipAutoScale: true } : {}),
        style: {
            overflow: "visible",
        },
    });

    if (!blob) {
        throw new Error("Unable to generate PNG");
    }

    await navigator.clipboard.write([
        new ClipboardItem({
            "image/png": blob,
        }),
    ]);
};